import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class TermDepositAccountService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `termdepositaccount?isMaintenance=${forMaintenance}`).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `termdepositaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  create(termDepositAccount: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount', termDepositAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createWithTransactions(transactionData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount', transactionData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  update(termDepositAccount: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'termdepositaccount', termDepositAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `termdepositaccount/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeInstallments(termDepositInstallmentData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount/compute', termDepositInstallmentData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  computeClosureData(accountId: number, completedDays: number): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `termdepositaccount/closure/${accountId}?completedDays=${completedDays}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  closeAccount(closureData: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'termdepositaccount/close', closureData).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getInterestPaymentDetails(accountId: number, generalLedgerId: number, customerId: number, isCustomer: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl +
      `termdepositaccount/interestpayment/${accountId}?generalLedgerId=${generalLedgerId}&&customerId=${customerId}&&isCustomer=${isCustomer}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
}
